// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eswitch_fpg_web--style-module--loader--WaNgTSEoh9U52h5SKg8T {
  height: "450vh";
  display: "flex";
  justify-content: "center";
  align-items: "center";
  margin-top: 350px;
}

.eswitch_fpg_web--style-module--authButton--ZyDaVGcEFSlNVOsguL8H {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
}

.eswitch_fpg_web--style-module--paddingBtm--QEbmHomXwfDl4qfVvEO1 {
  padding-bottom: 32px;
}

.eswitch_fpg_web--style-module--mrgTop22--xZEzQaMEcXNnnYA6dusn {
  margin-top: 22px;
}

.eswitch_fpg_web--style-module--mrgBtm32--HC7AIgaMRtFNfoL64NPn {
  margin-bottom: 32px;
}

.eswitch_fpg_web--style-module--mrgTop54--xCTXQyvpZXkwX6PAF1cy {
  margin-top: 54px;
}

.eswitch_fpg_web--style-module--mrgTop80--ZRm2mvPSy1luGbS1M78O {
  margin-top: 80px;
}

@media (max-width: 599px) {
  .eswitch_fpg_web--style-module--mrgTop80--ZRm2mvPSy1luGbS1M78O {
    margin-top: 40px;
  }
}

.eswitch_fpg_web--style-module--mainInfoTitle--VMX6WKVDR9Ao2aJqlXCm {
  text-align: center !important;
  margin-bottom: 5rem !important;
  font-family: var(--fmc-font--ford-motion) !important;
  font-size: 44px !important;
  margin-bottom: 20px !important;
}

.eswitch_fpg_web--style-module--comparisonTableHeading--VDLB7ouJBOFWou8_bMp4 {
  font-family: var(--fmc-font--ford-motion) !important;
}

.eswitch_fpg_web--style-module--padLeft40--tsaNp8v2t3gX0ZrKAP3z {
  padding-left: 40px;
}`, "",{"version":3,"sources":["webpack://./src/App.module.scss","webpack://./src/components/style.module.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;ACCJ;;ADEA;EACI,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;ACCJ;;AAXA;EACI,oBAAA;AAcJ;;AAXA;EACI,gBAAA;AAcJ;;AAXA;EACI,mBAAA;AAcJ;;AAXA;EACI,gBAAA;AAcJ;;AAXA;EACI,gBAAA;AAcJ;;AAZI;EAHJ;IAIQ,gBAAA;EAeN;AACF;;AAVA;EACI,6BAAA;EACA,8BAAA;EACA,oDAAA;EACA,0BAAA;EACA,8BAAA;AAaJ;;AAVA;EACI,oDAAA;AAaJ;;AATA;EACI,kBAAA;AAYJ","sourcesContent":[".loader {\n    height: '450vh';\n    display: 'flex';\n    justify-content: 'center';\n    align-items: 'center';\n    margin-top: 350px;\n}\n\n.authButton {\n    margin-top: 20px;\n    display: flex;\n    justify-content: flex-end;\n    margin-right: 10px;\n}\n\n$fds-breakpoints: (\n  'fds-xs': 360px,\n  'fds-sm': 600px,\n  'fds-md': 1024px,\n  'fds-lg': 1440px,\n  'fds-xl': 1920px\n);\n\n$fds-breakpoints-max: (\n  'fds-xxs': 359px,\n  'fds-xs': 599px,\n  'fds-sm': 1023px,\n  'fds-md': 1439px,\n  'fds-lg': 1919px\n);\n\n$fds-breakpoints-landscape-max: (\n  'handheld': 480px,\n  'tablet': 1024px\n);\n\n$custom-breakPoints-max:(\n  'tablet':767px,\n  'desktop':1023px\n);\n\n$custom-breakPoints-min:(\n  'tablet':768px,\n  'desktop':1023px\n)\n\n","@import \"../App.module.scss\";\n\n.paddingBtm {\n    padding-bottom: 32px;\n}\n\n.mrgTop22 {\n    margin-top: 22px;\n}\n\n.mrgBtm32 {\n    margin-bottom: 32px;\n}\n\n.mrgTop54 {\n    margin-top: 54px;\n}\n\n.mrgTop80 {\n    margin-top: 80px;\n\n    @media (max-width: map-get($fds-breakpoints-max,  'fds-xs')) {\n        margin-top: 40px;\n    }\n\n}\n\n\n.mainInfoTitle {\n    text-align: center !important;\n    margin-bottom: 5rem !important;\n    font-family: var(--fmc-font--ford-motion) !important;\n    font-size: 44px !important;\n    margin-bottom: 20px !important;\n}\n\n.comparisonTableHeading {\n    font-family: var(--fmc-font--ford-motion) !important;\n}\n\n\n.padLeft40{\n    padding-left: 40px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `eswitch_fpg_web--style-module--loader--WaNgTSEoh9U52h5SKg8T`,
	"authButton": `eswitch_fpg_web--style-module--authButton--ZyDaVGcEFSlNVOsguL8H`,
	"paddingBtm": `eswitch_fpg_web--style-module--paddingBtm--QEbmHomXwfDl4qfVvEO1`,
	"mrgTop22": `eswitch_fpg_web--style-module--mrgTop22--xZEzQaMEcXNnnYA6dusn`,
	"mrgBtm32": `eswitch_fpg_web--style-module--mrgBtm32--HC7AIgaMRtFNfoL64NPn`,
	"mrgTop54": `eswitch_fpg_web--style-module--mrgTop54--xCTXQyvpZXkwX6PAF1cy`,
	"mrgTop80": `eswitch_fpg_web--style-module--mrgTop80--ZRm2mvPSy1luGbS1M78O`,
	"mainInfoTitle": `eswitch_fpg_web--style-module--mainInfoTitle--VMX6WKVDR9Ao2aJqlXCm`,
	"comparisonTableHeading": `eswitch_fpg_web--style-module--comparisonTableHeading--VDLB7ouJBOFWou8_bMp4`,
	"padLeft40": `eswitch_fpg_web--style-module--padLeft40--tsaNp8v2t3gX0ZrKAP3z`
};
export default ___CSS_LOADER_EXPORT___;
